import { combineReducers } from 'redux';

import appReducer from './App/reducers';
import proFormReducer from './SubmissionPro/reducers';
import adminFormReducer from './SubmissionAdmin/reducers';
import leadReducer from './Leads/reducers';
import projectReducer from './Projects/reducers';
import leadSettingsReducer from './Settings/Leads/reducers';
import projectSettingsReducer from './Settings/Projects/reducers';
import projectItemReducer from './ProjectTools/Project/reducers';
import notesReducer from './ProjectTools/Notes/reducers';
import noteReducer from './ProjectTools/Notes/Note/reducers';
import billingReducer from './Billing/reducers';

const rootReducer = combineReducers({
  global: appReducer,
  proForm: proFormReducer,
  adminForm: adminFormReducer,
  leads: leadReducer,
  projects: projectReducer,
  settings: combineReducers({ leadSettings: leadSettingsReducer, projectSettings: projectSettingsReducer }),
  projectTools: combineReducers({ project: projectItemReducer, notes: notesReducer, note: noteReducer }),
  billing: billingReducer,
});

export default rootReducer;
